import Swiper, { Pagination } from 'swiper';
import CustomCursor from '../custom-cursor';

const init = () => {
  const studioLinks = document.querySelectorAll('a[href*="/studio"]');

  if (!studioLinks.length) return;

  const createModal = () => {
    const modal = document.createElement('div');
    modal.id = 'studio-modal';
    modal.className = 'fixed bg-black bg-opacity-0 flex items-end justify-end z-[10000] opacity-0'
    + ' transition-all duration-500 ease-in-out top-0 right-0 w-full h-full';
    const pageClass = 'bg-wild-metallic-olive w-[1095px] max-w-full h-full relative transform translate-x-full'
      + ' transition-transform duration-500 ease-in-out text-wild-dark';
    const buttonClass = 'relative top-16 md:top-32 mr-16 md:mr-32 ml-auto -mb-48 h-48 w-48'
      + ' flex items-center justify-center bg-wild-dark z-[20]';
    const buttonSvg = ''
      + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">'
      // eslint-disable-next-line max-len
      + '<path d="M1.08085 14.0095L-0.00927734 12.9193L5.90972 6.99995L-0.00927734 1.11808L1.08085 0.0279541L7.00022 5.94695L12.8821 0.0279541L13.9722 1.11808L8.05322 6.99995L13.9722 12.9193L12.8821 14.0095L7.00022 8.09045L1.08085 14.0095Z" fill="#DCFF00"/>'
      + '</svg>';
    modal.innerHTML = `
      <div id="studio-panel" class="${pageClass}">
        <button id="close-studio-modal" class="${buttonClass}">
          ${buttonSvg}
        </button>
        <div id="studio-content-container" class="h-full overflow-scroll">
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  };

  const loadStudioContent = async () => {
    try {
      const response = await fetch('/studio', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const studioContent = doc.querySelector('#studio-content') || doc.querySelector('main') || doc.querySelector('body');

      return studioContent ? studioContent.innerHTML : html;
    } catch (e) {
      console.error(e);
      return '';
    }
  };

  const showModal = async () => {
    let modal = document.getElementById('studio-modal');

    if (!modal) {
      modal = createModal();
    }

    const panel = modal.querySelector('#studio-panel');

    modal.classList.remove('opacity-0', 'pointer-events-none');
    modal.classList.add('bg-opacity-50');
    document.body.style.overflow = 'hidden';

    setTimeout(() => {
      panel.classList.remove('translate-x-full');
      panel.classList.add('translate-x-0');
    }, 50);

    const content = await loadStudioContent();
    const contentContainer = modal.querySelector('#studio-content-container');
    contentContainer.innerHTML = content;

    const closeBtn = modal.querySelector('#close-studio-modal');
    const handleClose = () => {
      panel.classList.remove('translate-x-0');
      panel.classList.add('translate-x-full');

      modal.classList.remove('bg-opacity-50');
      modal.classList.add('bg-opacity-0');

      setTimeout(() => {
        modal.classList.add('opacity-0', 'pointer-events-none');
        document.body.style.overflow = '';
      }, 500);
    };

    closeBtn.addEventListener('click', handleClose);

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        handleClose();
      }
    });

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleClose();
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
  };

  studioLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      showModal().then(() => {
        const studioSliders = document.getElementById('studio-modal').getElementsByClassName('slider--general');
        if (!studioSliders || studioSliders.length === 0) {
          return;
        }
        for (let i = 0; i < studioSliders.length; i += 1) {
          const slidesPerView = (studioSliders[i].classList.contains('js-staff-slider')) ? 2 : 1;
          new Swiper(studioSliders[i], {
            slidesPerView: 'auto',
            slidesPerGroup: slidesPerView,
            effect: 'slide',
            loop: false,
            allowTouchMove: true,
            spaceBetween: 24,
            pagination: {
              el: '.js-slider-pagination',
              clickable: true,
              bulletClass: 'pagination-bullet',
              bulletActiveClass: 'pagination-bullet-active',
            },
            breakpoints: {
              1024: {
                spaceBetween: 32,
                slidesPerGroup: 1,
                simulateTouch: false,
              },
            },
            modules: [Pagination],
          });
        }

        CustomCursor.init();
      });
    });
  });
};

export default {
  init,
};
